import { is } from "ramda";

export const marginProps = (props) => `
${props.marginBottom && `margin-bottom: ${is(String, props.marginBottom) ? props.marginBottom : "1em"}`};
${props.marginTop && `margin-top: ${is(String, props.marginTop) ? props.marginTop : "1em"}`};
${props.marginLeft && `margin-left: ${is(String, props.marginLeft) ? props.marginLeft : "1em"}`};
${props.marginRight && `margin-right: ${is(String, props.marginRight) ? props.marginRight : "1em"}`};
${props.margin && `margin: ${is(String, props.margin) ? props.margin : "1em"}`};
${
  props.marginVertical &&
  `
  margin-top: ${is(String, props.marginVertical) ? props.marginVertical : "1em"};
  margin-bottom: ${is(String, props.marginVertical) ? props.marginVertical : "1em"};
`
};
${
  props.marginHorizontal &&
  `
  margin-left: ${is(String, props.marginHorizontal) ? props.marginHorizontal : "1em"};
  margin-right: ${is(String, props.marginHorizontal) ? props.marginHorizontal : "1em"};
`
};
`;

export const paddingProps = (props) => `
${props.paddingBottom && `padding-bottom: ${is(String, props.paddingBottom) ? props.paddingBottom : "1em"}`};
${props.paddingTop && `padding-top: ${is(String, props.paddingTop) ? props.paddingTop : "1em"}`};
${props.paddingLeft && `padding-left: ${is(String, props.paddingLeft) ? props.paddingLeft : "1em"}`};
${props.paddingRight && `padding-right: ${is(String, props.paddingRight) ? props.paddingRight : "1em"}`};
${props.padding && `padding: ${is(String, props.padding) ? props.padding : "1em"}`};
${
  props.paddingVertical &&
  `
  padding-top: ${is(String, props.paddingVertical) ? props.paddingVertical : "1em"};
  padding-bottom: ${is(String, props.paddingVertical) ? props.paddingVertical : "1em"};
`
};
${
  props.paddingHorizontal &&
  `
  padding-left: ${is(String, props.paddingHorizontal) ? props.paddingHorizontal : "1em"};
  padding-right: ${is(String, props.paddingHorizontal) ? props.paddingHorizontal : "1em"};
`
};
`;

export const positioningProps = (props) => `
  ${props.relative && "position: relative"};
  ${props.absolute && "position: absolute"};
  ${props.static && "position: static"};
  ${props.fixed && "position: fixed"};
`;
